import { makeAutoObservable } from 'mobx';
import { validateBounce } from './validateBounce';

export class BounceData {
  priceToBreak = 0;
  // tradePlan = {};

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.priceToBreak = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateBounce(this.priceToBreak);
    return result;
  };
  returnJson = () => {
    return {
      priceToBreak: this.priceToBreak,
    };
  };

  //specific methods
  setBreakPrice = (price) => {
    this.priceToBreak = price;
  };
}
